export const cbcrReportId = "1956f88a-3274-4c96-8997-88cd5b47cfb7";
export const pillarTwoReportId = "38886143-1857-4733-82d2-288cdb7f09b8";